import Vue from 'vue'

const registerEventListener = (el, binding) => {
  el.querySelectorAll('.mention').forEach(item => {
    let dataIdAttribute = item.attributes['data-id']
    if (dataIdAttribute && dataIdAttribute.value) {
      item.addEventListener('click', () => {
        binding.value(dataIdAttribute.value)
      })
    }
  })
}

Vue.directive('mentionify', {
  bind: registerEventListener,
  update: registerEventListener
})
